import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[validateCpf][formControlName],[validateCpf][formControl],[validateCpf][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: ValidateCpfDirective, multi: true },
    ],
})
export class ValidateCpfDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        const raw = (control.value || '').replace(/\D/g, '');

        // deixa que `required`/`minLength` tratem os vazios ou incompletos
        if (raw.length < 11) {
            return null;
        }

        return this.isValidCpf(raw) ? null : { cpfInvalido: true };
    }

    /* ---------- validação dos dígitos verificadores ---------- */
    private isValidCpf(cpf: string): boolean {
        if (/^(.)\1{10}$/.test(cpf)) return false; // todos dígitos iguais

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += +cpf[i] * (10 - i);
        let dv1 = (soma * 10) % 11;
        dv1 = dv1 === 10 ? 0 : dv1;
        if (dv1 !== +cpf[9]) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += +cpf[i] * (11 - i);
        let dv2 = (soma * 10) % 11;
        dv2 = dv2 === 10 ? 0 : dv2;
        return dv2 === +cpf[10];
    }
}
